import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavBar from './Pages/Home/NavBar';
import Home from "./Pages/Home/Homescreen";
import Artwork from "./Pages/Artwork";
import About from "./Pages/About";
import Projects from "./Pages/Dev";
import Research from "./Pages/Research";

function App() {
  return (
    <div className="App">
      <Router>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/art" element={<Artwork />} />
          <Route path="/about" element={<About />} />
          <Route path="/dev" element={<Projects />} />
          <Route path="/research" element={<Research />} />
          <Route path="*" element={<div>404 Not Found</div>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
